<template>
  <header class="header" :class="{ 'header-scrolled': isScrolled }">
    <div class="container">
      <div class="header-content">
        <router-link to="/" class="logo-wrapper">
          <h1 class="logo">Your Cars LLC</h1>
        </router-link>

        <button
          class="menu-toggle"
          type="button"
          aria-label="Toggle navigation"
          @click="toggleMenu"
        >
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </button>

        <nav class="navigation" :class="{ open: isMenuOpen }">
          <ul class="nav-list">
            <li class="nav-item">
              <router-link to="/" class="nav-link" @click="closeMenu"
                >Home</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/buy" class="nav-link" @click="closeMenu"
                >Buy</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/lease" class="nav-link" @click="closeMenu"
                >Lease</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/#about" class="nav-link" @click="closeMenu"
                >About</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/#contact" class="nav-link" @click="closeMenu"
                >Contact</router-link
              >
            </li>
            <li class="nav-item cta-item">
              <a href="tel:+14243334220" class="nav-phone">
                <svg
                  class="phone-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22 16.92V19.92C22 20.4704 21.7893 20.9996 21.4142 21.3746C21.0391 21.7497 20.5099 21.96 19.96 21.96C17.4207 21.8001 14.9558 21.0746 12.77 19.84C10.7429 18.7117 8.97465 17.1599 7.58 15.29C6.2987 13.2087 5.44977 10.8659 5.14 8.40997C5.02902 7.86935 5.23816 7.3195 5.61442 6.94098C5.99068 6.56247 6.52052 6.34936 7.06 6.33997H10.06C11.0455 6.32954 11.886 7.06869 12 8.04997C12.072 8.93236 12.244 9.8035 12.51 10.65C12.723 11.3192 12.5537 12.0494 12.06 12.56L10.79 13.83C12.0578 15.933 13.8734 17.7486 15.9763 19.0163L17.2463 17.7463C17.7569 17.2526 18.4871 17.0833 19.1563 17.2963C20.0028 17.5623 20.874 17.7343 21.7563 17.8063C22.7573 17.9231 23.5015 18.7892 23.4763 19.79L22 16.92Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                (424) 333-4220
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "MainHeader",
  data() {
    return {
      lastScrollTop: 0,
      showHeader: true,
      isScrolled: false,
      isMenuOpen: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      this.showHeader = true;
      this.isScrolled = st > 50;
      this.lastScrollTop = st <= 0 ? 0 : st;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (this.isMenuOpen) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
    },
    closeMenu() {
      this.isMenuOpen = false;
      document.body.classList.remove("overflow-hidden");
    },
  },
  beforeRouteUpdate(to, from, next) {
    window.scrollTo(0, 0);
    next();
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  transition: all 0.3s ease;
  padding: 1rem 0;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  backdrop-filter: blur(8px);

  &.header-scrolled {
    padding: 0.5rem 0;
    background-color: rgba(255, 255, 255, 0.98);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  }

  .container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 2rem;

    @media (max-width: 768px) {
      padding: 0 1.5rem;
    }
  }

  &-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo-wrapper {
    text-decoration: none;
    position: relative;
    display: flex;
    align-items: center;
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-2px);
    }
  }

  .logo {
    font-size: 2rem;
    font-weight: 700;
    letter-spacing: -0.5px;
    color: #111;
    margin: 0;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, #ee800a, #ff7043);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;

    @media (max-width: 768px) {
      font-size: 1.75rem;
    }
  }

  .menu-toggle {
    display: none;
    background: transparent;
    border: none;
    padding: 10px;
    cursor: pointer;
    position: relative;
    z-index: 1001;

    @media (max-width: 991px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .bar {
      display: block;
      width: 26px;
      height: 3px;
      background-color: #111;
      margin: 4px 0;
      transition: 0.3s;
      border-radius: 3px;
    }

    &:hover .bar {
      background: linear-gradient(to right, #ee800a, #ff7043);
    }
  }

  .navigation {
    @media (max-width: 991px) {
      position: fixed;
      top: 0;
      right: -100%;
      width: 100%;
      height: 100vh;
      background-color: rgba(255, 255, 255, 0.98);
      padding-top: 120px;
      transition: all 0.4s ease;
      overflow-y: auto;
      backdrop-filter: blur(10px);

      &.open {
        right: 0;
      }
    }
  }

  .nav-list {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    align-items: center;

    @media (max-width: 991px) {
      flex-direction: column;
      align-items: center;
      gap: 2rem;
    }
  }

  .nav-item {
    margin: 0 1rem;
    position: relative;

    @media (max-width: 991px) {
      margin: 0;
    }
  }

  .nav-link {
    color: #333;
    text-decoration: none;
    font-size: 1.05rem;
    font-weight: 500;
    padding: 0.5rem 0.25rem;
    transition: all 0.3s ease;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 0;
      height: 2px;
      background: linear-gradient(to right, #ee800a, #ff7043);
      transition: all 0.3s ease;
      border-radius: 2px;
    }

    &:hover {
      color: #ee800a;

      &:after {
        width: 100%;
      }
    }

    @media (max-width: 991px) {
      font-size: 1.25rem;
      padding: 0.75rem 1.5rem;
      display: block;

      &:after {
        bottom: -8px;
        height: 3px;
      }
    }
  }

  .cta-item {
    margin-left: 2rem;

    @media (max-width: 991px) {
      margin: 1rem 0 0 0;
    }
  }

  .nav-phone {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #fff;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 600;
    padding: 0.75rem 1.5rem;
    background: linear-gradient(135deg, #ee800a, #ff7043);
    border-radius: 50px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    z-index: 1;
    box-shadow: 0 6px 15px rgba(238, 128, 10, 0.2);

    .phone-icon {
      width: 18px;
      height: 18px;
      stroke-width: 2;
      transition: transform 0.3s ease;
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(238, 128, 10, 0.3);

      .phone-icon {
        transform: rotate(-10deg);
      }
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 4px 10px rgba(238, 128, 10, 0.2);
    }

    @media (max-width: 991px) {
      font-size: 1.1rem;
      padding: 0.85rem 1.75rem;
    }
  }
}

.navigation.open {
  + .menu-toggle {
    .bar:nth-child(1) {
      transform: rotate(-45deg) translate(-5px, 6px);
    }

    .bar:nth-child(2) {
      opacity: 0;
    }

    .bar:nth-child(3) {
      transform: rotate(45deg) translate(-5px, -6px);
    }
  }
}

.overflow-hidden {
  overflow: hidden;
}
</style>
